import { useState } from 'react'
import { Button } from '@mui/material'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import Programa from '../../../components/Programa/Programa'
import PrimeTable from '../../../components/PrimeTable'
import { metodoPrograma } from '../../../components/api'
import { setError } from '../../../components/alerts'
import { formatarCpfCnpj } from '../../../utils/formatacoes'
import Edicao from './Edicao'
import { CODIGO } from './formulario'

export default function EmpresaNotaFiscal() {
  const [refresh, setRefresh] = useState(0)
  const [linhaEdicao, setLinhaEdicao] = useState(null)
  const atualiza = () => setRefresh((valor) => valor + 1)
  const fechaEdicao = () => setLinhaEdicao(null)

  const exclui = async (linha) => {
    try {
      const resposta = await metodoPrograma(
        'exclui',
        { idEmpresaNotaFiscal: linha[0] },
        CODIGO,
      )
      if (resposta.status) atualiza()
    } catch {
      setError('Não foi possível excluir a empresa. Tente novamente.')
    }
  }

  return (
    <Programa
      codigo={CODIGO}
      ferramentas={
        linhaEdicao === null ? (
          <Button startIcon={<MdAdd />} onClick={() => setLinhaEdicao([])}>
            Incluir empresa
          </Button>
        ) : (
          <Button startIcon={<MdArrowBack />} onClick={fechaEdicao}>
            Voltar à lista
          </Button>
        )
      }
    >
      {linhaEdicao === null ? (
        <PrimeTable
          key={refresh}
          codigo={CODIGO}
          action="lista"
          parametros={{}}
          refresh={refresh}
          rows={10}
          head={[
            'Código',
            'Razão social',
            'CNPJ',
            'Cidade IBGE',
            'E-mail',
            'Telefone',
            'Série',
          ]}
          line={(linha) => [
            linha[0],
            linha[1],
            formatarCpfCnpj(linha[2] || ''),
            linha[3],
            linha[4],
            linha[5],
            linha[7] == null ? '' : String(linha[7]),
          ]}
          onRowSelect={setLinhaEdicao}
          onDelete={{ index: 10, action: exclui }}
        />
      ) : (
        <Edicao linha={linhaEdicao} close={fechaEdicao} onSalvo={atualiza} />
      )}
    </Programa>
  )
}
